<template>
  <div class="main-wrap">
    <!-- tab切换 start -->
    <van-tabs
      v-model="activeTabs"
      background="transparent"
      color="#fff"
      title-active-color="#fff"
      title-inactive-color="#fff"
      line-width="50"
      line-height="2"
    >
      <van-tab title="全部库存"></van-tab>
      <van-tab title="可用库存"></van-tab>
    </van-tabs>
    <!-- tab切换 end -->

    <!-- 内容主体区域 start -->
    <van-row>
      <!-- 数据统计区域  start -->
      <van-row class="header-info-wrap">
        <van-collapse class="info-card" v-model="activeCollapse">
          <van-collapse-item name="1">
            <!-- 插槽 自定义标题区域 -->
            <template #title>
              <div>
                库存总量: <span class="blue bold">{{ total }}</span>
              </div>
            </template>

            <van-grid direction="horizontal" :column-num="3" :border="false">
              <van-grid-item class="grid-item" v-for="item in productQuantityList" :key="item.id">
                <van-badge dot color="#1989fa"> </van-badge>
                <div class="label">{{ item.label + ":" }}</div>
                <div class="num">{{ item.value }}</div>
              </van-grid-item>
            </van-grid>
          </van-collapse-item>
        </van-collapse>
      </van-row>
      <!-- 数据统计区域  end -->
			
      <!-- 搜索区域 start -->
      <van-row>
        <div class="midden-search-wrap" style="position: relative;">
					<div class="key-search-select-box" v-if="searchKeyShow">
						<ul>
							<li 
								v-for="(v, i) in searchKeys" 
								:key="i" 
								:class="(searchKeyAct === i ? 'active' : '')"
								@click="searchCommand(i)"
							>{{v.name}}</li>
						</ul>
					</div>
          <div class="search-input-wrap">
						<div class="key-search-select" @click="searchKeySelectClick">
							{{ searchKeys[searchKeyAct]['name'] }}<van-icon name="play" :class="(searchKeyShow ? 'van-icon-play-active' : '')"/>
						</div>
            <input class="input key-search-input" v-model="sku" type="text" placeholder="支持模糊查询" @blur="searchKeyBlur"/>
            <div class="btn" @click="submit">搜索</div>
          </div>
          <van-row class="search-type-wrap">
            <van-col
              span="8"
              :class="['type-item', activeSearchType == 1 ? 'active' : '']"
              @click="selectSearchTypeHandle(1)"
              >品类<van-icon name="play"
            /></van-col>
            <van-col
              span="8"
              :class="['type-item', activeSearchType == 2 ? 'active' : '']"
              @click="selectSearchTypeHandle(2)"
              >仓库<van-icon name="play"
            /></van-col>
            <van-col
              span="8"
              :class="['type-item', activeSearchType == 3 ? 'active' : '']"
              @click="selectSearchTypeHandle(3)"
              >库存量<van-icon name="play"
            /></van-col>
          </van-row>

          <van-row class="search-list-wrap" v-if="activeSearchType != 0">
            <!-- 品类 -->
            <van-grid :column-num="3" :border="false" gutter="10" v-show="activeSearchType == 1">
              <van-grid-item
                :class="['grid-item', item.selected ? 'active' : '']"
                v-for="item in categorySearchList"
                :key="item.id"
                :text="item.name"
                @click="item.selected = !item.selected"
              />
            </van-grid>
            <!-- 仓库 -->
            <van-grid :column-num="3" :border="false" gutter="10" v-show="activeSearchType == 2">
              <van-grid-item
                :class="['grid-item', item.selected ? 'active' : '']"
                v-for="item in warehouseSearchList"
                :key="item.id"
                :text="item.name"
                @click="item.selected = !item.selected"
              />
            </van-grid>
            <!-- 库存量 -->
            <van-row class="stock-input-wrap" type="flex" justify="space-around" v-show="activeSearchType == 3">
              <van-col span="10" class="min-input-wrap">
                <input type="tel" v-model="stockSearch.minimum" placeholder="最小数量" />
              </van-col>
              <van-col span="1"><van-divider :style="{ borderColor: '#e5e5e5' }"/></van-col>
              <van-col span="10" class="max-input-wrap">
                <input type="tel" v-model="stockSearch.maximum" placeholder="最大数量" />
              </van-col>
            </van-row>
            <!-- 分割线 -->
            <van-divider :style="{ boderColor: '#d4d4d4' }"></van-divider>
            <van-row class="search-submit-wrap" type="flex" justify="space-around">
              <button class="clearBtn" @click="clearSearch">清空条件</button>
              <button class="submitBtn" @click="submit">确&nbsp;&nbsp;认</button>
            </van-row>
          </van-row>
        </div>
      </van-row>
      <!-- 搜索区域 end -->

      <!-- 列表区域 start -->
      <van-list
        class="footer-list-wrap"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :error.sync="error"
        error-text="点击重新加载"
        @load="onLoad"
      >
        <van-row class="sku-list-wrap" v-for="item in dataList" :key="item.id">
          <van-row class="sku-item-card" type="flex" @click="showCardInfoDialog(item.id, item.products_id, item.sku)">
            <van-row class="left">
              <van-row class="sku">{{ item.sku }}</van-row>
              <van-row>{{ "名称:" + item.name }}</van-row>
              <van-row>{{ "型号:" + item.model }}</van-row>
              <van-row v-if="item.upccoding">{{ "料号:" + item.upccoding }}</van-row>
              <van-row>{{ "库存编码:" + item.inventory_code }}</van-row>
            </van-row>
            <van-row class="right">
              <van-row class="tag tag_01">{{ item.category_name }}</van-row>
              <van-row class="tag tag_02">{{ item.warehouse }}</van-row>
              <van-row class="tag tag_03">{{ "库存量:" + item.stocknum }}</van-row>
            </van-row>

            <!-- <van-row class="position-right">
              <div class="tag tag_01">{{ item.category_name }}</div>
              <div class="tag tag_02">{{ item.warehouse }}</div>
              <div class="tag tag_03">{{ "库存量:" + item.stocknum }}</div>
            </van-row>
            <van-row class="sku">{{ item.sku }}</van-row>
            <van-row>{{ "名称:" + item.name }}</van-row>
            <van-row>{{ "型号:" + item.model }}</van-row>
            <van-row v-if="item.upccoding">{{ "料号:" + item.upccoding }}</van-row>
            <van-row>{{ "库存编码:" + item.inventory_code }}</van-row> -->
          </van-row>
        </van-row>
      </van-list>
      <!-- 列表区域 end -->
    </van-row>
    <!-- 内容主体区域 end -->

    <van-dialog
      v-model="cardShow"
      className="cardDialog"
      theme="round-button"
      confirm-button-color="#51596e"
      confirmButtonText="关 闭"
    >
      <header class="header-title">
        <p class="sku">{{ cardInfoSku }}</p>
      </header>
      <main class="main-container">
        <div class="item" v-for="(item, index) in cardInfoList" :key="index">
          {{ item.label + ":&nbsp;&nbsp;" + item.value }}
        </div>
      </main>
      <!-- <footer class="footer-btn"></footer> -->
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      error: false,
      loading: false,
      finished: false,
      activeTabs: 0,
      activeCollapse: [],
      activeSearchType: 0,
      categorySearchList: [],
      category: "", // 选中的品类参数, 用于params中的参数
      warehouseSearchList: [],
      warehouse: "", // 选中的仓库参数, 用于params中的参数
      stockSearch: {
        minimum: "",
        maximum: "",
      },
      total: 0, // 库存总量
      productQuantityList: [],
      dataList: [],
      page: 1,
      sku: "",
      flag: false, // 是否正在请求的标识
      cardShow: false,
      cardInfoSku: "", // card对话框中的sku
      cardInfoList: [],
			
			searchKeyShow: false,
			searchKeyAct: 0,
			searchKeys: [
				{'val': 'all', 'name': '自动识别'},
				{'val': 'sku', 'name': 'SKU'},
				{'val': 'name', 'name': '产品名称'},
			],
			
    };
  },
  watch: {
    activeTabs() {
      console.log("发起请求");
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });

      this.initStatistics().then(() => {
        console.log("请求成功");
        toast.clear();
      });
    },

    /**
     * 监听品类列表的选中状态,拼接 category参数
     */
    categorySearchList: {
      handler() {
        let result = "";
        this.categorySearchList.filter((item) => {
          if (item.selected == true) {
            result += item.id + ",";
          }
        });
        this.category = result.slice(0, -1);
        // console.log(this.category);
      },
      deep: true,
    },

    /**
     * 监听仓库列表的选中状态,拼接 category参数
     */
    warehouseSearchList: {
      handler() {
        let result = "";
        this.warehouseSearchList.filter((item) => {
          if (item.selected == true) {
            result += item.id + ",";
          }
        });
        this.warehouse = result.slice(0, -1);
        // console.log(this.warehouse);
      },
      deep: true,
    },
		
  },
  computed: {},
  methods: {
    selectSearchTypeHandle(value) {
      if (this.activeSearchType === value) return (this.activeSearchType = 0);
      this.activeSearchType = value;
    },
    /**
     * 清空搜索条件
     */
    clearSearch() {
      // console.log("清空搜索条件");
      this.categorySearchList = this.categorySearchList.filter((item) => {
        item.selected = false;
        return item;
      });
      this.warehouseSearchList = this.warehouseSearchList.filter((item) => {
        item.selected = false;
        return item;
      });
      this.stockSearch = { minimum: "", maximum: "" };
      this.$toast("已清空搜索条件");
    },
    /**
     * 提交搜索表单
     */
    submit() {
      // 收起search列表
      this.activeSearchType = 0;
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.dataList = [];
      this.onLoad();
    },
    /**
     * 初始化统计数据与搜索类型数据
     */
    async initStatistics() {
      this.submit(); // 刷新列表
      let params = { status: this.activeTabs };
      let { data } = await this.$post(this.$api.stGetKucuntongji, params);

      // 品类数据
      this.categorySearchList = data.categorys.filter((item) => {
        item.selected = false;
        return item;
      });

      // 仓库数据
      this.warehouseSearchList = data.warehouses.filter((item) => {
        item.selected = false;
        return item;
      });

      this.total = data.data.total;
      this.productQuantityList = data.data.list;
      // console.log(data);
    },
    /**
     * 分页加载数据
     */
    async onLoad() {
      // console.log("this.loading: ", this.loading);
      if (this.flag == true) return console.log("不要重复请求");

      this.flag = true;
      let { minimum, maximum } = this.stockSearch;
      if (minimum) {
        minimum = Number(minimum);
      }
      if (maximum) {
        maximum = Number(maximum);
      }
      console.log(minimum != "", maximum != "");

      if (minimum != "" && maximum != "") {
        // 两个参数
        if (!/(^[1-9]\d*$)/.test(maximum) || maximum < minimum) {
          this.flag = false;
          this.loading = false;
          return this.$toast.fail("最大值必须大于最小值");
        }
      } else {
        // 一个参数
        if (minimum != "" && !/(^[0-9]\d*$)/.test(minimum)) {
          this.loading = false;
          this.flag = false;
          return this.$toast.fail("最小值必须为非负数");
        }
        if (maximum != "" && !/(^[0-9]\d*$)/.test(maximum)) {
          this.loading = false;
          this.flag = false;
          return this.$toast.fail("最大值必须为非负数");
        }
      }

			
      let params = {
        status: this.activeTabs,
        skey: this.searchKeys[this.searchKeyAct]['val'],
				sval: this.sku,
        page: this.page,
        minimum,
        maximum,
        category: this.category,
        warehouse: this.warehouse,
      };
      try {
        let { data } = await this.$post(this.$api.stGetKucuntongjiList, params);
        // 数据全部加载完毕
        if (data.length == 0) this.finished = true;

        // console.log("this.page: " + this.page);

        this.dataList.push(...data);
        // 请求完成
        this.page += 1;
      } catch (error) {
        this.error = true;
      } finally {
        this.loading = false;
        this.flag = false;
      }
    },
    /**
     * 显示sku详细数据对话框
     */
    async showCardInfoDialog(inventory_id, products_id, sku) {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      // 同步对话框中的sku
      this.cardInfoSku = sku;
      let params = { inventory_id, products_id };
      let { data } = await this.$post(this.$api.stGetKucunxiangqing, params);
      this.cardInfoList = data;
      // 显示对话框
      this.cardShow = true;
    },
		
		searchCommand(ind) {
			this.searchKeyAct = ind;
		},
		searchKeySelectClick() {
			this.searchKeyShow = true;
			document.querySelector('.key-search-input').focus();
		},
		
		searchKeyBlur() {
			if (this.searchKeyShow) {
				setTimeout(() => {this.searchKeyShow = false;}, 300);
			}
		},
  },
  mounted() {
    this.initStatistics();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "库存管理" });
    });
  },
};
</script>

<style lang="scss" scoped>
$blue: #1989fa;
$green: #00baad;
$gray: #677588;
.blue {
  color: $blue;
}
.bold {
  font-weight: bold;
}

.main-wrap {
  padding-top: 20px;
  height: 100%;
  background: linear-gradient(180deg, #2a82e4 138px, #f3f5f9 138px, #f3f5f9);

  .header-info-wrap {
    padding: 15px;

    .info-card {
      border-radius: 8px;
      overflow: hidden;

      // 修改vant样式
      ::v-deep .van-collapse-item__content {
        padding: 0;
      }

      .grid-item {
        font-size: 11px;
        color: #51596e;

        // 修改vant样式
        ::v-deep .van-grid-item__content {
          padding: 10px 8px;
          justify-content: flex-start;
        }

        .label {
          margin-left: 5px;
        }
      }
    }
  }

  .midden-search-wrap {
    padding: 15px;
    background-color: #fff;

    .search-input-wrap {
      box-sizing: border-box;
      display: flex;
      width: 100%;
      height: 32px;
      border-radius: 16px;
      overflow: hidden;

      .input {
        flex: 1;
        padding-left: 16px;
        width: 80%;
        height: 100%;
        outline: none;
        line-height: 100%;
        border: none;
        background-color: #efefef;
      }
      .input::placeholder {
        color: #a6a6a6;
      }
      .btn {
        width: 65px;
        line-height: 32px;
        text-align: center;
        color: #f5f5f5;
        letter-spacing: 0.5em;
        font-size: 12px;
        background-color: #2a82e4;
      }
    }

    .search-type-wrap {
      .type-item {
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        .van-icon {
          margin-left: 8px;
          transform: rotate(90deg);
          transition: transform 0.5s;
        }

        &.active {
          color: $green;

          .van-icon {
            transform: rotate(-90deg);
          }
        }
      }
    }

    .search-list-wrap {
      padding-top: 20px;

      .grid-item {
        margin: 3px 0;
        color: #757877;

        ::v-deep .van-grid-item__content {
          padding: 4px 0;
          background-color: #f1f1f1;
        }

        &.active {
          color: #3dae7d;
          ::v-deep .van-grid-item__content {
            background-color: #d9f3e6;
          }
        }
      }

      .stock-input-wrap {
        .min-input-wrap,
        .max-input-wrap {
          background-color: #eaeaea;
          border-radius: 2px;
          overflow: hidden;

          input {
            padding-left: 12px;
            width: 100%;
            height: 100%;
            border: none;
            background-color: transparent;
            outline: none;
          }
          input::placeholder {
            color: #a6a6a6;
          }
        }
      }

      .search-submit-wrap {
        .clearBtn {
          width: 154px;
          height: 35px;
          color: #fff;
          border: none;
          border-radius: 5px;
          background-color: $gray;
          outline: none;
        }
        .submitBtn {
          width: 154px;
          height: 35px;
          color: #fff;
          border: none;
          border-radius: 5px;
          background-color: $green;
          outline: none;
        }
      }
    }
  }

  .footer-list-wrap {
    padding: 15px;

    .sku-item-card {
      position: relative;
      margin-bottom: 10px;
      padding: 10px 15px;
      background-color: #fff;
      border-radius: 6px;

      .left {
        margin-right: 10px;
        flex: 1;

        .sku {
          position: relative;
          line-height: 1.5em;
        }
        .sku::before {
          content: "";
          position: absolute;
          top: 0;
          left: -6px;
          height: 80%;
          border-left: 2px solid $green;
          // background-color: $green;
        }
        .sku ~ .van-row {
          font-size: 12px;
          line-height: 18px;
          color: #a8a8a8;
        }
      }

      .right {
        box-sizing: border-box;
        display: flex;
        justify-content: space-around;
        flex-direction: column;

        .tag {
          margin: 0 0 0 auto;
          padding: 2px 10px;
          color: #fff;
          font-size: 12px;
          border-radius: 12px;
        }
        .tag_01 {
          background-color: $gray;
        }
        .tag_02 {
          background-color: $blue;
        }
        .tag_03 {
          background-color: $green;
        }
      }
    }
  }

  .cardDialog {
    box-sizing: border-box;
    padding: 20px 20px 0;
    border-radius: 5px;

    .header-title {
      position: relative;
      color: #232834;
      .sku::before {
        content: "";
        position: absolute;
        top: 0;
        left: -6px;
        height: 80%;
        border-left: 3px solid $green;
      }
    }

    .main-container {
      margin-top: 10px;
      .item {
        font-size: 12px;
        color: #677588;
        line-height: 2em;
      }
    }
  }
	
	.key-search-select {
		width: 80px;
		text-align: center;
		line-height: 32px;
		background: #e3e4e5;
		cursor: pointer;
		.van-icon-play-active {
			transform: rotate(90deg);
		}
	}
 .key-search-select-box {
	 position: absolute;
	 top:44px;
	 background: white;
	 width: 76px;
	 left: 18px;
	 text-align:center;
	 padding:12px 0px 8px;
	 line-height: 26px;
	 border-bottom-left-radius: 5px;
	 border-bottom-right-radius: 5px;
	 box-shadow: 0 0 0 0px rgba(155, 168, 152, 0.4), 0 0 0 0px rgba(155, 168, 152, 0.4), 0 0 0 1px rgba(155, 168, 152, 0.4);
	 z-index: 99;
	 gap: 2px;
		li {
			cursor: pointer;
		}
		.active {
			background: linear-gradient(to bottom, white,  rgba(217,221,216,0.4), rgba(217,221,216,0.4), rgba(217,221,216,0.4), white);
		}
 }	
}


</style>
